<template>
  <div>
    <heading class="mb-3" :level="1" size="sm">{{ bp('containerUpdate') }}</heading>
    <div
      v-for="(configContainer, index) in configContainers"
      :key="index"
      class="flex items-start justify-between mb-3"
    >
      <ContainerIndicator :base-properties="baseProperties" :container="configContainer" />
      <div class="flex items-center ml-6">
        <span class="text-md mr-2">{{ bp('quantity') }}</span>
        <input
          v-model="configContainer.count"
          type="number"
          class="form-control w-12"
          :class="{'border border-red': errorMessage}"
        />
      </div>
    </div>
    <Callout v-if="errorMessage" class="text-sm text-left max-w-xs" type="alert" qaid="containerConfigurationWarning">{{
      errorMessage
    }}</Callout>
    <div class="buttons">
      <trek-button
        primary
        block
        :disabled="errorMessage"
        qaid="containerConfigurationConfirmButton"
        @click="submitContainers"
      >
        <span v-html="bp('containerConfirm')"></span>
      </trek-button>
    </div>
    <div class="buttons">
      <trek-button secondary block qaid="containerConfigurationCloseButton" @click="$emit('close')">
        <span v-html="bp('cancel')"></span>
      </trek-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import get from 'lodash/get';
import {mapActions} from 'vuex';
import TrekButton from '@/components/TrekButton';
import Callout from '@/components/Callout';
import Heading from '@/components/Heading';

export default {
  name: 'ContainerConfiguration',

  components: {
    ContainerIndicator: () => import('@/components/containers/drop-ship/ContainerIndicator'),
    Callout,
    Heading,
    TrekButton,
  },

  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    containers: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      configContainers: [
        {id: 'DSCont_40Hift', count: 0},
        {id: 'DSCont_40ft', count: 0},
        {id: 'DSCont_20ft', count: 0},
      ],
      responseErrorMessage: null,
    };
  },

  computed: {
    totalContainersConfigured() {
      return this.configContainers.reduce((total, config) => {
        let count = parseInt(config.count);
        count = count ? (count > 0 ? count : 0) : 0;
        return total + count;
      }, 0);
    },

    errorMessage() {
      if (this.responseErrorMessage) {
        return this.responseErrorMessage;
      } else if (this.totalContainersConfigured < 1) {
        return this.bp('errorSelectOne');
      } else if (this.totalContainersConfigured > 15) {
        return this.bp('maxContainer');
      }

      return null;
    },
  },

  mounted() {
    this.resetState();
  },

  methods: {
    resetState() {
      this.responseErrorMessage = null;

      this.configContainers.find((container) => container.id === 'DSCont_40Hift').count = get(
        this,
        'containers.fortyHiFeetContainers.length',
        0
      );

      this.configContainers.find((container) => container.id === 'DSCont_40ft').count = get(
        this,
        'containers.fortyFeetContainers.length',
        0
      );

      this.configContainers.find((container) => container.id === 'DSCont_20ft').count = get(
        this,
        'containers.twentyFeetContainers.length',
        0
      );
    },

    getCleansedQtyFromContainer(containerId) {
      let result = this.configContainers.find((container) => container.id === containerId).count;
      if (!result || result < 0) result = 0;
      return result;
    },

    submitContainers() {
      const payload = {
        containerQtyFortyHi: this.getCleansedQtyFromContainer('DSCont_40Hift'),
        containerQtyForty: this.getCleansedQtyFromContainer('DSCont_40ft'),
        containerQtyTwenty: this.getCleansedQtyFromContainer('DSCont_20ft'),
      };

      this.responseErrorMessage = null;

      axios
        .put('/containers', payload)
        .then((response) => {
          const status = get(response, 'data.meta.feedback.type');
          if (status === 'success') {
            this.$emit('close');
            this.fetchMiniCart();
            this.fetchCart();
          } else if (status === 'alert') {
            this.responseErrorMessage = get(response, 'data.meta.feedback.message.basePropertyValue');
          } else {
            this.responseErrorMessage = this.bp('tryAgain');
          }
        })
        .catch((error) => {
          this.responseErrorMessage = this.bp('tryAgain');
          console.log(error);
        });
    },

    ...mapActions('cart', ['fetchCart']),
    ...mapActions('miniCart', ['fetchMiniCart']),
  },
};
</script>
